export enum RestrictSelectionType {
  SameZone = 'SameZone',
  SpecificSections = 'SpecificSections',
  SameSection = 'SameSection',
}
